/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {CustomerDTO} from "../../common/customer-dto.model";

export class CrmCustomerDTO extends CustomerDTO {

  customerLoyaltyCode: string | undefined = undefined;
  customerStage: string | undefined = undefined;
  callFrequencyValue: string | undefined = undefined;
  customerCreditUuid: string | undefined = undefined;
  customerProfileUuid: string | undefined = undefined;
}
